import * as React from 'react'
import { MainWatcherConnected } from './MainWatcherConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const MainWatcherExamples = () => {
  return (
    <div className="MainWatcherExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <MainWatcherConnected />
      </Provider>
    </div>
  )
}
